import { __require as _ } from "./main67.js";
var e, a;
function c() {
  if (a) return e;
  a = 1;
  var i = _();
  function n(s) {
    var r = this.__data__, t = i(r, s);
    return t < 0 ? void 0 : r[t][1];
  }
  return e = n, e;
}
export {
  c as __require
};
